<script setup>

import { defineProps, defineEmits} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import PagamentoEletronicoConteudo from "./PagamentoEletronicoConteudo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "pagamentoEletronico",
    "pagamentoEletronicoService",
    "visualizandoPagamentoEletronico",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:pagamentoEletronico",
    "update:visualizandoPagamentoEletronico",
    "update:controlesDesativados"
]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//=========== Altera Visualizando Pagamento Eletronico =============//
//==================================================================//

const alteraVisualizandoPagamentoEletronico = (update) =>{

    emits('update:visualizandoPagamentoEletronico',update);

};

//==================================================================//
//=============== Altera Pagamento Eletronico ======================//
//==================================================================//

const alteraPagamentoEletronico = (update={})=>{

    emits('update:pagamentoEletronico',{
        ...props.pagamentoEletronico,
        ...update
    });

};

//==================================================================//
//===================== Altera Justificativa =======================//
//==================================================================//

const alteraJustificativa = (justificativa) =>{

    alteraPagamentoEletronico({
        justificativa: justificativa
    })

}

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.visualizandoPagamentoEletronico"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :pagamentoEletronico="props.pagamentoEletronico"
                    :pagamentoEletronicoService="props.pagamentoEletronicoService"
                    :controlesDesativados="props.controlesDesativados"
                    :visualizandoPagamentoEletronico="props.visualizandoPagamentoEletronico"
                    @update:visualizandoPagamentoEletronico="alteraVisualizandoPagamentoEletronico"
                    @update:controlesDesativados="alteraControlesDesativados"
                    @update:justificativa="alteraJustificativa"
                >
                </BarraNavegacao>

                <PagamentoEletronicoConteudo
                    :controlesDesativados="props.controlesDesativados"
                    :pagamentoEletronico="props.pagamentoEletronico"
                    @update:pagamentoEletronico="alteraPagamentoEletronico"
                    @update:justificativa="alteraJustificativa"
                >
                </PagamentoEletronicoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

